import { useQuery } from 'react-query'

import { useSvcCompareVersionsContext } from '@dc-shared-web/providers'
import { fetchComparisonList } from '@dc-shared-web/hooks/api/comparison/fetchComparisonList'

import { COMPARISON_LIST_QUERY_KEY } from '@dc-shared-web/hooks/api/queryKeys'
import type { VCCardProps } from '@dc-shared-web/hooks/api/comparison/types'

export const useFetchComparisonList = (
  crunchUuid: string,
  enabled: boolean = true
) => {
  const svcCompareVersionApiClient = useSvcCompareVersionsContext()
  return useQuery<VCCardProps[]>({
    queryKey: [COMPARISON_LIST_QUERY_KEY, crunchUuid],
    queryFn: () =>
      fetchComparisonList(svcCompareVersionApiClient, { crunchUuid }),
    enabled: !!crunchUuid && enabled,
  })
}
